// src/pages/BillingSuccessRedirect.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ROUTES = {
  personal: "/personal-dashboard",
  family: "/family-dashboard",
  school: "/school-dashboard",
  free: "/free-dashboard",
};

function normalizeTo(v) {
  if (!v) return null;
  const s = String(v).trim();
  if (!s) return null;
  if (s.startsWith("/")) return s; // already a path
  const k = s.toLowerCase();
  if (ROUTES[k]) return ROUTES[k];
  return null;
}

function detectDashboard() {
  // 1) If user was on a dashboard before, honor it.
  const last = localStorage.getItem("lastDashboard");
  if (last && last.startsWith("/")) return last;

  // 2) Try subscription snapshot (if you ever keep one here)
  try {
    const snap = JSON.parse(localStorage.getItem("ysw.sub.snapshot") || "null") || {};
    const kind = String(snap.packageKind || "").toLowerCase();
    const key = String(snap.packageKey || "").toLowerCase();
    const familySeats = Number(snap.seats?.family || 0);

    if (kind === "school" || key.startsWith("school_")) return ROUTES.school;
    if (kind === "family" || key.startsWith("family") || familySeats >= 2) return ROUTES.family;
    if (kind === "personal" || key === "personal") return ROUTES.personal;
  } catch {}

  // 3) Fall back to local selected plan
  const sel = (localStorage.getItem("selectedPlan") || "").toLowerCase();
  if (sel.startsWith("school_")) return ROUTES.school;
  if (sel.startsWith("family")) return ROUTES.family;
  if (sel === "personal") return ROUTES.personal;

  // 4) Only *now* check schoolId as a hint
  const schoolId = localStorage.getItem("schoolId");
  if (schoolId) return ROUTES.school;

  // 5) Final safe default
  return ROUTES.personal;
}


export default function BillingSuccessRedirect() {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const qs = new URLSearchParams(search);
    const hasSessionId = Boolean(qs.get("session_id"));
    const isTopup = qs.get("topup") === "1";
    const to = normalizeTo(qs.get("to"));

    // Real Checkout returns (new sub / plan change / top-up)
    if (hasSessionId || isTopup) {
      navigate(`/checkout/success${search}`, { replace: true });
      return;
    }

    // Billing portal return (no changes)
    const fallback = to || detectDashboard();
    navigate(fallback, { replace: true });
  }, [navigate, search]);

  return null;
}
